import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Grid, Box, IconButton, Typography, useTheme } from "@mui/material";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { tokens } from "../../../theme";

export default function DeleteMessage({
  showDeleteMessage,
  setShowDeleteMessage,
  agree,
  cancel,
  customText,
  typeBtn,
}) {
  const theme = useTheme();
  const themeMod = useTheme().palette.mode;
  const colors = tokens(theme.palette.mode);
  const handleClose = () => {
    const checkedFnDeleteMessage = Boolean(setShowDeleteMessage);
    if (checkedFnDeleteMessage) {
      if (typeBtn === "footer") {
        setShowDeleteMessage((prev) => ({ ...prev, showWarning: false }));
      } else {
        setShowDeleteMessage(false);
      }
    }
  };

  const handleAgree = () => {
    const checkedAgree = Boolean(agree);
    if (checkedAgree) {
      agree();
    }
    handleClose();
  };

  return (
    <Dialog
      open={showDeleteMessage}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <Grid
        container
        sx={{ background: themeMod === "dark" ? "#161B25" : "#F7FBFF" }}
      >
        <Grid item xs={12}>
          <Box
            display={"flex"}
            justifyContent={"space-between"}
            alignItems={"center"}
            px={1}
            py={2}
          >
            <Box display={"flex"} alignItems={"center"} columnGap={1}>
              <ErrorOutlineIcon color="error" />
              <Typography>هشدار</Typography>
            </Box>
            <Box>
              <IconButton size="small" onClick={handleClose}>
                <CloseOutlinedIcon color='error' fontSize='small' />
              </IconButton>
            </Box>
          </Box>
        </Grid>

        <Grid item xs={11.5} mx={"auto"}>
          <Box
            py={2}
            px={2}
            borderRadius={2}
            sx={{
              background: themeMod === "dark" ? "#1E232D" : "#FFF",
            }}
          >
            {customText ? (
              <Typography>{customText}</Typography>
            ) : (
              <Typography>
                بعد از حذف امکان بازیابی وجود نخواهد داشت! آیا از حذف اطمینان
                دارید؟
              </Typography>
            )}
          </Box>
        </Grid>

        <Grid item xs={12} pt={2} px={1}>
          <DialogActions>
            <Button
           variant="contained"
           sx={{borderRadius:'8px',backgroundColor: "#1E6AFD",}}


              onClick={handleAgree}
              autoFocus
            >
              بله
            </Button>
            <Button
                variant="outlined"
                color="error"
             
                sx={{ borderRadius:'8px' }}
              onClick={handleClose}
            >
              لغو
            </Button>
          </DialogActions>
        </Grid>
      </Grid>
    </Dialog>
  );
}
/**==============================================
 *                uesr:javadBoroji   1402/10/30
 *
 *    TODO: add customText
 *
 *
 *
 *
 *=============================================**/
